module.exports = __webpack_public_path__ + "img/transferencia.41a1173e.png";